<form class="teksti apk">
  @if (commonError()) {
    <div class="red-text common-error">{{ commonError() | translate | async }}</div>
  }

  <div class="apk-form-title">
    {{ 'ajopaivakirja.oma-ajoneuvon-kaytto' | translate | async }}
  </div>
  <mat-form-field>
    <mat-label>{{ 'ajopaivakirja.auton-kayton-km-maara' | translate | async }}</mat-label>
    <input decimalNumberField matInput [numberOfDecimals]="0" class="alignLeft" [formField]="lomake.kokonaisKmMaara" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ ('ajopaivakirja.auton-kaytto-tyoajoissa' | translate | async) + ' (km)' }}</mat-label>
    <input decimalNumberField matInput [numberOfDecimals]="0" class="alignLeft" [formField]="lomake.tyoAjoissaKm" />
    @if (naytaVirhe(lomake.tyoAjoissaKm, 'toolarge')) {
      <mat-error>{{ 'ajopaivakirja.auton-kaytto-tyoajoissa-too-large-error' | translate | async }}</mat-error>
    }
  </mat-form-field>
  <div [class.mat-form-field-invalid]="onkoVirhe(lomake.tiedotPerustuvat, 'required')" [style.color]="naytaVirhe(lomake.tiedotPerustuvat, 'required') ? 'red' : 'black'" class="apk-radio-container" style="margin-top: 20px">
    <div [class.dark-gray-text]="!lomake.kokonaisKmMaara().value()" class="apk-radio-label">
      {{ 'ajopaivakirja.auton-tiedot-perustuvat' | translate | async }}
      @if (lomake.kokonaisKmMaara().value()) {
        <span aria-hidden="true" class="mat-placeholder-required mat-form-field-required-marker"> *</span>
      }
    </div>
    <mat-radio-group [formField]="lomake.tiedotPerustuvat" style="display: flex; flex-direction: column">
      <mat-radio-button class="apk-radio-button" [value]="'ajopaivakirjaan'">{{ 'ajopaivakirja.ajopaivakirjaan' | translate | async }}</mat-radio-button>
      <mat-radio-button class="apk-radio-button" [value]="'muuhun selvitykseen'">{{ 'ajopaivakirja.muuhun-selvitykseen' | translate | async }}</mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="apk-form-title">
    {{ 'ajopaivakirja.tyomatkat' | translate | async }}
  </div>
  <mat-form-field>
    <mat-label>{{ 'ajopaivakirja.yli-10h-lukumaara' | translate | async }}</mat-label>
    <input decimalNumberField matInput [numberOfDecimals]="0" class="alignLeft" [formField]="lomake.yli10hKotimaanMatkojenLukumaara" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'ajopaivakirja.yli-6h-lukumaara' | translate | async }}</mat-label>
    <input decimalNumberField matInput [numberOfDecimals]="0" class="alignLeft" [formField]="lomake.yli6hKotimaanMatkojenLukumaara" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'ajopaivakirja.ulkomaan-lukumaara' | translate | async }}</mat-label>
    <input decimalNumberField matInput [numberOfDecimals]="0" class="alignLeft" [formField]="lomake.ulkomaanMatkapaivienLukumaara" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'ajopaivakirja.ulkomaan-paivarahojen-yhteismaara' | translate | async }}</mat-label>
    <input decimalNumberField matInput [formField]="lomake.ulkomaanPaivarahojenYhteismaara" class="alignLeft" [numberOfDecimals]="0" />
  </mat-form-field>
  <div class="apk-form-title">
    {{ 'ajopaivakirja.tyohuonevahennys' | translate | async }}
  </div>
  <div>
    <mat-radio-group style="display: flex; flex-direction: column" [formField]="lomake.kotiYrityksenTyotilana">
      <mat-radio-button [value]="'ei-vahennysta'">
        <div style="font-size: 14px; white-space: pre-wrap">{{ 'ajopaivakirja.ei-tyohuonevahennysta' | translate | async }}</div>
      </mat-radio-button>
      <mat-radio-button [value]="'paasaantoinen'">
        <div style="white-space: pre-wrap">{{ 'ajopaivakirja.kotia-paasaantoisesti' | translate: { vahennys: paasaantoinenKotiVahennys } | async }}</div>
      </mat-radio-button>
      <mat-radio-button [value]="'osa-aikainen'">
        <div style="white-space: pre-wrap">{{ 'ajopaivakirja.kotia-osa-aikaisesti' | translate: { vahennys: osaaikainenKotiVahennys } | async }}</div>
      </mat-radio-button>
      <mat-radio-button [value]="'satunnainen'">
        <div style="white-space: pre-wrap">{{ 'ajopaivakirja.kotia-satunnaisesti' | translate: { vahennys: satunnainenKotiVahennys } | async }}</div>
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <div style="margin-top: 30px">
    <div>
      <app-primary-button (click)="tallenna()" actionId="Tallenna ajopäiväkirja" [actionContext]="$any(lomake().value())">Tallenna</app-primary-button>
    </div>
  </div>
</form>
